export const FIELD_ADDRESS = "address";
export const FIELD_DESCRIPTION = "description";
export const FIELD_START_TIME = "start-time";
export const FIELD_PLAYER_NUM = "player-num";
export const FIELD_LEAGUE_ID = "league-id";
export const FIELD_HOME_TEAM = "home-team";
export const FIELD_AWAY_TEAM = "away-team";
export const FIELD_HOME_SCORE = "home-team-score";
export const FIELD_AWAY_SCORE = "away-team-score";

export const DEFAULT_PLAYER_NUM = 7;
